var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-footer",staticStyle:{"margin-top":"10px"}},[_c('span',[_vm._v("技术支持：湖南华菱电子商务有限公司")]),_c('span',{staticStyle:{"margin-left":"50px"}},[_vm._v("咨询电话：0731-89952046")])])
}]

export { render, staticRenderFns }